import { AboutSection } from "@/components/home/AboutSection";
import { ContactSection } from "@/components/home/ContactSection";
import { HeroSection } from "@/components/home/HeroSection";
import { NichesStrip } from "@/components/home/NichesStrip";
import { PlansSection } from "@/components/home/PlansSection";
import { ProblemSection } from "@/components/home/ProblemSection";
import { ProcessSection } from "@/components/home/ProcessSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { SystemSection } from "@/components/home/SystemSection";
import { FaqSection } from "@/components/sections/FaqSection";
import { FinalCta } from "@/components/sections/FinalCta";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import { SHOW_SISTEMA_LUCENTIA } from "@/config/features";
import { usePageSeo } from "@/hooks/usePageSeo";

export function HomePage() {
  usePageSeo("/");

  return (
    <main id="main-content" tabIndex={-1} className="outline-none">
      <HeroSection />
      <NichesStrip />
      <ProblemSection />
      <AboutSection />
      <ProcessSection />
      {SHOW_SISTEMA_LUCENTIA ? <SystemSection /> : null}
      <TestimonialsSection />
      <ServicesSection />
      <PlansSection />
      <FaqSection path="/" />
      <ContactSection />
      <FinalCta />
    </main>
  );
}
